import React, { useContext, useEffect } from "react";
import AOS from "aos"; 
import "aos/dist/aos.css"; 
import { apivalue } from "../Alldata/Data";
import { CartProvider, useCart } from "react-use-cart";
import Navbar from "../Components/Navbar";
import Mainhero from "./Mainhero";
import Footer from "../Components/Footer";

function Page() {
  const { addItem } = useCart();
  const data = useContext(apivalue);

  useEffect(() => {
    AOS.init({ duration: 1000 }); 
  }, []);

  return (
    
    <div className="untree_co-section product-section before-footer-section">
      <div className="container">
        <div className="row">
          {data.map((el) =>
            el.id < 21 ? (
              <div
                className="col-12 col-md-4 col-lg-3 mb-5"
                key={el.id}
                data-aos="fade-up" 
              >
                <a className="product-item">
                  <img
                    src={el.images[0]}
                    alt="img"
                    className="img-fluid product-thumbnail"
                  />
                  <h3 className="product-title">{el.title}</h3>
                  <strong className="product-price">${el.price}</strong>
                  <span className="icon-cross" onClick={() => addItem(el)}>
                    <img src="images/cross.svg" alt="img" className="img-fluid" />
                  </span>
                </a>
              </div>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
}

function Shop() {
  return (
    <CartProvider>
      <Navbar />
      <Mainhero value={<h1>Shop</h1>} />
      <Page />
      <Footer />
    </CartProvider>
  );
}

export default Shop;
